import { apiSlice } from './apiSlice';

export interface SsoLoginArgs {
  emis_username: string;
  /** 1 = emis, 2 = tnemis */
  type: number;
}

export interface SsoLoginResponse {
  dataStatus: boolean;
  message?: string;
  records?: {
    token: string;
  };
}

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Exchanges an SSO-provided username for a real session token.
    // Mirrors Angular's authService.login(username, _, 3) → POST /sso_login.
    ssoLogin: builder.mutation<SsoLoginResponse, SsoLoginArgs>({
      query: ({ emis_username, type }) => ({
        url: 'sso_login',
        method: 'POST',
        body: { records: { emis_username, type } },
        service: 'login',
      }),
    }),
  }),
});

export const { useSsoLoginMutation } = authApi;
